import { ComponentProps } from 'react';
import { Input, Label, Text } from '@/components/atoms';

export interface FormFieldProps extends Omit<ComponentProps<typeof Input>, 'error'> {
  label: string;
  error?: string;
  htmlFor?: string;
}

export function FormField({ label, error, htmlFor, id, ...inputProps }: FormFieldProps) {
  const fieldId = id || htmlFor;

  return (
    <div>
      <Label htmlFor={fieldId}>{label}</Label>
      <Input id={fieldId} error={!!error} {...inputProps} />
      {error && (
        <Text variant="muted" className="text-red-600 text-sm mt-1">
          {error}
        </Text>
      )}
    </div>
  );
}
